import { render, staticRenderFns } from "./main-support.vue?vue&type=template&id=741872c2&scoped=true&"
import script from "./main-support.vue?vue&type=script&lang=js&"
export * from "./main-support.vue?vue&type=script&lang=js&"
import style0 from "./main-support.vue?vue&type=style&index=0&id=741872c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741872c2",
  null
  
)

export default component.exports